'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { DragSource } from 'react-dnd';
import I18n from 'I18n';
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { makeGetCellOrRowById, makeGetCellOrRowParentId } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { buildActionsForEmptyColumn, buildActionsForEmptyRow, BaseResponsiveEmptyContainerToolbar } from './BaseResponsiveEmptyContainerToolbar';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import EmptyContainerIcon from './EmptyContainerIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const dragSource = {
  beginDrag(props) {
    const {
      id,
      parentId,
      draggingStartedAndDeselectExisting,
      layoutSectionId,
      moduleIcon
    } = props;
    const dragItem = {
      dragId: id,
      dragParentId: parentId,
      isRow: props.isRow,
      isTopMostRow: false,
      originLayoutSectionId: layoutSectionId,
      iconUrl: moduleIcon
    };
    draggingStartedAndDeselectExisting(dragItem);
    return dragItem;
  },
  endDrag(props, monitor) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = props;
    draggingStoppedAndReselectIfNeeded(monitor.getItem(), monitor.didDrop());
  }
};
function dragCollect(dndConnect, monitor) {
  return {
    connectDragPreview: dndConnect.dragPreview(),
    connectDragSource: dndConnect.dragSource(),
    isDragging: monitor.isDragging()
  };
}
const mapStateToProps = () => {
  const getCellOrRowParentId = makeGetCellOrRowParentId();
  const getCellOrRowById = makeGetCellOrRowById();
  return (state, ownProps) => {
    if (ownProps.id) {
      const node = getCellOrRowById(state, {
        layoutSectionId: ownProps.layoutSectionId,
        id: ownProps.id
      });
      return {
        isRow: node ? node.isRow() : false,
        parentId: getCellOrRowParentId(state, {
          layoutSectionId: ownProps.layoutSectionId,
          id: ownProps.id
        })
      };
    }
    return {};
  };
};
const mapDispatchToProps = {
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction
};
class ResponsiveEmptyContainerToolbar extends Component {
  componentDidMount() {
    const {
      connectDragPreview
    } = this.props;
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }
  render() {
    const {
      id,
      isRow,
      layoutSectionId,
      top,
      left,
      onDropdownOpenChange,
      responsiveSize,
      dispatch,
      bus,
      connectDragSource
    } = this.props;
    const handleTooltip = isRow ? I18n.text('inpage.actionToolbar.emptyRow') : I18n.text('inpage.actionToolbar.emptyColumn');
    const buildActionsFunc = isRow ? buildActionsForEmptyRow : buildActionsForEmptyColumn;
    const actions = buildActionsFunc(id, layoutSectionId, dispatch, bus);
    return /*#__PURE__*/_jsx(BaseResponsiveEmptyContainerToolbar, {
      icon: EmptyContainerIcon,
      actions: actions,
      onDropdownOpenChange: onDropdownOpenChange,
      style: {
        top,
        left
      },
      responsiveSize: responsiveSize,
      handleTooltip: handleTooltip,
      connectDragSource: connectDragSource
    });
  }
}
ResponsiveEmptyContainerToolbar.propTypes = {
  id: PropTypes.string,
  isRow: PropTypes.bool,
  layoutSectionId: PropTypes.string,
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  responsiveSize: PropTypes.string.isRequired,
  onDropdownOpenChange: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  bus: PropTypes.object.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired
};
ResponsiveEmptyContainerToolbar.defaultProps = {
  responsiveSize: DEFAULT_RESPONSIVE_SIZE
};
export default connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(ResponsiveEmptyContainerToolbar));